import React from 'react';

import DistanceHelper from './DistanceHelper';
import { convertFromSeconds } from './TimeUtils';

const Result = ({ times, distance }) => {
    console.log('Times in result', times);

    const swimDistance = DistanceHelper.swimDistance(distance);
    const bikeDistance = DistanceHelper.bikeDistance(distance);
    const runDistance = DistanceHelper.runDistance(distance);

    const swimTime = (swimDistance / 1000) * times.swim;
    const bikeTime = bikeDistance * times.bike;
    const runTime = runDistance * times.run;

    const totalDistance = (swimDistance / 1000) + bikeDistance + runDistance;
    const total = swimTime + times.t1 + bikeTime + times.t2 + runTime;

    return (
        <div>
            <h2>Result</h2>

            <table className="table">
                <thead>
                    <tr>
                        <th>Discipline</th>
                        <th>Distance</th>
                        <th className="text-right">Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Swim</td>
                        <td>{swimDistance} m</td>
                        <td className="text-right">{convertFromSeconds(swimTime)}</td>
                    </tr>
                    <tr>
                        <td>T1</td>
                        <td>&nbsp;</td>
                        <td className="text-right">{convertFromSeconds(times.t1)}</td>
                    </tr>
                    <tr>
                        <td>Bike</td>
                        <td>{bikeDistance} km</td>
                        <td className="text-right">{convertFromSeconds(bikeTime)}</td>
                    </tr>
                    <tr>
                        <td>T2</td>
                        <td>&nbsp;</td>
                        <td className="text-right">{convertFromSeconds(times.t2)}</td>
                    </tr>
                    <tr>
                        <td>Run</td>
                        <td>{runDistance} km</td>
                        <td className="text-right">{convertFromSeconds(runTime)}</td>
                    </tr>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td>Total</td>
                        <td>{totalDistance} km</td>
                        <td className="text-right">{convertFromSeconds(total)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Result;
